import { render, staticRenderFns } from "./SpaymentreceiptsIndex.vue?vue&type=template&id=2391d4ca"
import script from "./SpaymentreceiptsIndex.vue?vue&type=script&lang=js"
export * from "./SpaymentreceiptsIndex.vue?vue&type=script&lang=js"
import style0 from "./SpaymentreceiptsIndex.vue?vue&type=style&index=0&id=2391d4ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports